module.exports = __webpack_public_path__ + "img/3.56b01489.png";